export default __webpack_public_path__ + "assets/images/lh_dashboard_2.53671f8.jpg";